class Importer {
  constructor(key=null, code=null, description=null) {
    this.key = key
    this.code = code
    this.description = description
  }

  toData() {
    return {
      key: this.key,
      code: this.code,
      description: this.description
    }
  }

  get id() {
    return this.key
  }

  set id(value) {
    this.key = value
  }
}

Importer.fromData = function fromData(data) {
  return new Importer(
    data.key || null,
    data.code || null,
    data.description || null
  )
}

/**
 * ステータス
 */
const ImportStatus = Object.freeze({
  READY: 1,
  LOADING: 2,
  FINISH: 10,
  ERROR: 999
})

export {
  Importer,
  ImportStatus
}
